export default {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  QUESTION: 'QUESTION',
  ERROR: 'ERROR',
  INFO: 'INFO',
  NONE: 'NONE',
};
